import { Type } from 'class-transformer';
import { IsArray, IsString, ValidateNested } from 'class-validator';

export class Attachment {
  @IsString()
  id?: string;

  @IsString()
  name?: string;

  data?: ArrayBuffer;
}

export class Email {
  @IsArray()
  @IsString({ each: true })
  to?: string[];

  @IsString()
  from?: string;

  @IsString()
  subject?: string;

  @IsString()
  content?: string;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => Attachment)
  attachments?: Attachment[];
}
